import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasClasificarmovimientosComponent ($q, $catalogos, FinanzasClasificarMovimientos, $filter) {
  var $ctrl = this,
    filter = $filter('filter'),
    cuentasBancarias;
  $ctrl.$onInit = $onInit;
  $ctrl.filtarCuentas = filtarCuentas;

  function $onInit () {
    $ctrl.empresa = null;
    $ctrl.cuentabancaria = null;
    $ctrl.cuentasbancarias = [];
    $ctrl.tiposdepositos = ['INDIVIDUAL', 'MASIVO'];
    $ctrl.$promise = $q.all({
      cuentasBancarias: $catalogos.get('cuentasBancarias'),
      empresas: FinanzasClasificarMovimientos.getEmpresas(),
    }).then(function (resolve) {
      cuentasBancarias = resolve.cuentasBancarias;
      $ctrl.empresas = resolve.empresas.data;
    });
  }

  function filtarCuentas () {
    $ctrl.cuentasbancarias = filter(cuentasBancarias, {
      ID_Cliente: $ctrl.empresa,
    });
    $ctrl.cuentabancaria = null;
  }
}

module.component('finanzasClasificarmovimientos', {
  controller: FinanzasClasificarmovimientosComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/component.js